import React from 'react';
import { Link } from 'react-router-dom';

export default function RealisationsPage() {
  const realisations = [
    { title: 'Maison traditionnelle — Lyon 7e', specs: '20 panneaux • 8 kWc • Août 2024', desc: 'Installation sur toiture tuiles avec optimiseurs de puissance. Économies immédiates dès le premier mois.', eco: '75%', img: '/assets/images/WhatsAppImage2024-08-06at13.21.54.jpeg' },
    { title: 'Maison moderne — Villeurbanne', specs: '16 panneaux • 6,4 kWc • Juin 2025', desc: 'Installation sur toiture plate avec système de lestage. Solution clé en main en 2 jours.', eco: '70%', img: '/assets/images/WhatsAppImage2025-06-24at19.35.44.jpeg' },
    { title: 'Maison ancienne rénovée — Rhône', specs: '24 panneaux • 9,6 kWc • Mars 2025', desc: 'Rénovation complète avec renforcement de charpente et isolation des combles combinée.', eco: '80%', img: '/assets/images/WhatsAppImage2025-03-25at11.40.57.jpeg' },
    { title: 'Maison en pierre — Ain', specs: '18 panneaux • 7,2 kWc • Oct 2024', desc: 'Installation respectueuse du patrimoine architectural avec panneaux haute esthétique.', eco: '65%', img: '/assets/images/WhatsAppImage2024-10-15at14.37.38.jpeg' },
  ];

  return (
    <>
      {/* Hero */}
      <section className="page-hero" style={{ background: "linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url('/assets/images/AdobeStock_208731473.jpeg') center/cover" }}>
        <div className="container" style={{ width: '100%' }}>
          <div className="hero-content">
            <h1 className="hero-title">Nos <span className="text-accent">Réalisations</span></h1>
            <p className="hero-subtitle">Découvrez nos installations chez des particuliers de la région lyonnaise. Des projets concrets, des économies réelles.</p>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="stats-section">
        <div className="container">
          <div className="stats-grid">
            {[
              { n: '500+', l: 'Installations réalisées' },
              { n: '98%', l: 'Clients satisfaits' },
              { n: '2019', l: "Depuis" },
              { n: '24h', l: 'Délai de réponse' },
            ].map((s) => (
              <div className="stat-item" key={s.l}>
                <div className="stat-number">{s.n}</div>
                <div className="stat-label">{s.l}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Realisations */}
      <section className="realisations-section">
        <div className="container">
          <div className="section-header">
            <h2>Nos dernières <span className="text-accent">réalisations</span></h2>
          </div>
          <div className="realisations-grid-compact">
            {realisations.map((r) => (
              <div className="realisation-card-small" key={r.title}>
                <h3>{r.title}</h3>
                <div className="realisation-specs"><span className="spec">{r.specs}</span></div>
                <p>{r.desc}</p>
                <div className="realisation-highlight">Économies : {r.eco}</div>
                <div className="realisation-image-compact">
                  <img src={r.img} alt={r.title} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="testimonials">
        <div className="container">
          <div className="section-header">
            <h2>Avis de nos <span className="text-accent">clients</span></h2>
          </div>
          <div className="testimonials-grid">
            {[
              { text: "Équipe très professionnelle. Installation réalisée en une journée. Je suis très satisfait des économies réalisées.", author: 'Pierre L.', ville: 'Lyon 7e' },
              { text: "Très bien accompagné du début à la fin. Les démarches administratives ont été faites à notre place. Je recommande.", author: 'Marie T.', ville: 'Villeurbanne' },
              { text: "Service irréprochable, installation propre et soignée. Les panneaux sont parfaitement intégrés à ma toiture.", author: 'Jean-Claude F.', ville: 'Décines' },
              { text: "Excellent rapport qualité/prix. L'installation s'est déroulée sans aucun problème et les économies sont au rendez-vous.", author: 'Sophie B.', ville: 'Meyzieu' },
            ].map((t) => (
              <div className="testimonial-card" key={t.author}>
                <div className="stars">★★★★★</div>
                <div className="testimonial-content"><p>{t.text}</p></div>
                <div className="testimonial-author">— {t.author} <span style={{ fontWeight: 'normal', color: '#7F8C8D', fontSize: '0.9rem' }}>({t.ville})</span></div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <div className="container">
          <h2>Rejoignez nos clients satisfaits !</h2>
          <p>Obtenez votre étude personnalisée gratuite et sans engagement</p>
          <div className="cta-buttons">
            <Link to="/#contact" className="btn btn-white" style={{ padding: '14px 30px', fontSize: '1rem' }}>Demander mon devis gratuit</Link>
            <a href="tel:0465845177" className="btn-outline-white" style={{ padding: '14px 30px', fontSize: '1rem' }}>Appeler le 04 65 84 51 77</a>
          </div>
        </div>
      </section>
    </>
  );
}
